import { render, staticRenderFns } from "./HeaderBrandTagline.vue?vue&type=template&id=4afd8c82&scoped=true"
import script from "./HeaderBrandTagline.vue?vue&type=script&lang=js"
export * from "./HeaderBrandTagline.vue?vue&type=script&lang=js"
import style0 from "./HeaderBrandTagline.vue?vue&type=style&index=0&id=4afd8c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd8c82",
  null
  
)

export default component.exports